export default __webpack_public_path__ + "static/media/100_19786.2c5b1109.jpg";